module.exports = __webpack_public_path__ + "static/img/tst2-05.b22f733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-05.jpg
// module id = sntv
// module chunks = 1